import React from "react";
import CalendarDatePicker from "ui/components/comp-507";
import TagsFilterCombobox from "components/directus/combobox/tags-filter";

const JobTimesheetDepartmentFilters = ({ filters, setFilters }) => {
  return (
    <div className="flex gap-2 flex">
      <TagsFilterCombobox
        value={filters?.tagId}
        onChange={(value) => setFilters({ ...filters, tagId: value })}
        for="timesheet"
        hideLabel
        className="w-40"
      />
      <CalendarDatePicker
        date={{
          from: filters.startDate,
          to: filters.endDate,
        }}
        setDate={(range) =>
          setFilters({ ...filters, startDate: range?.from, endDate: range?.to })
        }
      />
    </div>
  );
};

export default JobTimesheetDepartmentFilters;
